<div class="flex justify-between">
  <h1 mat-dialog-title class="text-2xl font-semibold mb-4 text-start d-flex">
    {{ data ? "Edit" : "Create" }} User
  </h1>
  <div class="absolute right-0 top-0 pr-4 pt-4">
    <button mat-icon-button [matDialogClose]="undefined">
      <mat-icon
        class="text-secondary"
        [svgIcon]="'heroicons_outline:x-mark'"
      ></mat-icon>
    </button>
  </div>
</div>

<form
  [formGroup]="userForm"
  (ngSubmit)="onSubmit()"
  class="space-y-4 overflow-scroll p-3"
>
  <div
    mat-dialog-content
    class="grid grid-cols-1 md:grid-cols-2 gap-4 user-form-container p-5"
  >
    <!-- Username -->
    <div class="col-span-1">
      <mat-form-field class="w-full" appearance="fill" floatLabel="always">
        <mat-label>Username</mat-label>
        <input
          matInput
          id="username"
          formControlName="username"
          type="text"
          placeholder="Enter your username"
          required
          (keypress)="allowOnlyAlphaNumAndDot($event)"
        />
        <mat-error *ngIf="userForm.controls['username'].hasError('required')"
          >Username is required</mat-error
        >
        <mat-error *ngIf="userForm.controls['username'].hasError('minlength')">
          Username must be at least 3 characters long
        </mat-error>
        <mat-error *ngIf="userForm.controls['username'].hasError('whitespace')">
          Username should not contain spaces
        </mat-error>
         <mat-error *ngIf="userForm.controls['username'].hasError('pattern')">

          Username can contain only letters, numbers, and dots

        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-span-1">
      <mat-form-field class="w-full" appearance="fill" floatLabel="always">
        <mat-label>First Name</mat-label>
        <input
          matInput
          id="firstName"
          formControlName="firstName"
          placeholder="Enter your first name"
          required
        />
        <mat-error *ngIf="userForm.controls['firstName'].hasError('required')">
          First name is required
        </mat-error>
        <mat-error *ngIf="userForm.controls['firstName'].hasError('pattern')">
          Only alphabets and spaces are allowed
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Last Name -->
    <div class="col-span-1">
      <mat-form-field class="w-full" appearance="fill" floatLabel="always">
        <mat-label>Last Name</mat-label>
        <input
          matInput
          id="lastName"
          formControlName="lastName"
          placeholder="Enter your last name"
          required
        />
        <mat-error *ngIf="userForm.controls['lastName'].hasError('required')">
          Last name is required
        </mat-error>
        <mat-error *ngIf="userForm.controls['lastName'].hasError('pattern')">
          Only alphabets and spaces are allowed
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Email -->
    <div class="col-span-1">
      <mat-form-field class="w-full" appearance="fill" floatLabel="always">
        <mat-label>Email Address</mat-label>
        <input
          matInput
          id="email"
          formControlName="email"
          type="email"
          placeholder="Enter your email address"
          required
        />
        <mat-error *ngIf="userForm.controls['email'].hasError('required')">
          Email is required
        </mat-error>
        <mat-error *ngIf="userForm.controls['email'].hasError('email')">
          Enter a valid email address
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Phone Number -->
    <div class="col-span-1"  *ngIf="!isIhcl">
      <mat-form-field class="w-full" appearance="fill" floatLabel="always">
        <mat-label>Mobile Number</mat-label>
        <input
          matInput
          id="phoneNumber"
          formControlName="phoneNumber"
          type="tel"
          placeholder="Enter your mobile number"
          
        />
        
        <mat-error *ngIf="userForm.controls['phoneNumber'].hasError('pattern')">
          Enter a valid 10-digit phone number
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Role ID -->
    <div class="col-span-1" [class.opacity-50]="isSubAdmin">
      <mat-form-field class="w-full" appearance="fill" floatLabel="always">
        <mat-label>Select Roles</mat-label>
        <mat-select formControlName="roleId" class="w-full">
          <mat-option>
            <ngx-mat-select-search
              [formControl]="roleFilterCtrl"
              placeholderLabel="Search roles..."
              noEntriesFoundLabel="No roles found"
            ></ngx-mat-select-search>
          </mat-option>

          <mat-option value="">Select Roles</mat-option>

          <mat-option *ngIf="isVendor" [value]="data?.roleId">
            Vendor Default
          </mat-option>

          <mat-option *ngFor="let role of filteredRoles | async" [value]="role._id">
            {{ role.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Is Sub-Admin -->
    <div class="col-span-1 flex items-center" *ngIf="!isVendor">
      <mat-checkbox (change)="onSubAdminToggle($event)" [checked]="isSubAdmin">
        Is Sub-Admin
      </mat-checkbox>
    </div>

<!-- Password Field -->
<!-- <div class="col-span-1" *ngIf="!data">
  <mat-form-field class="w-full" appearance="fill" floatLabel="always">
    <mat-label>Password</mat-label>
    <input
      matInput
      [type]="hidePassword ? 'password' : 'text'"
      id="password"
      formControlName="password"
      placeholder="Enter password"
      required
      autocomplete="new-password"
      form="dummy-form"
      name="new-password"
    />
    <button
      mat-icon-button
      matSuffix
      type="button"
      (click)="hidePassword = !hidePassword"
      [attr.aria-label]="'Toggle password visibility'"
      [attr.aria-pressed]="hidePassword"
    >
      <mat-icon>
        {{ hidePassword ? 'visibility_off' : 'visibility' }}
      </mat-icon>
    </button>

    <mat-error *ngIf="userForm.controls['password'].hasError('required')">
      Password is required
    </mat-error>
    <mat-error *ngIf="userForm.controls['password'].hasError('minlength')">
      Password must be at least 8 characters long
    </mat-error>
  </mat-form-field>
</div> -->



<!-- Confirm Password Field -->
<!-- <div class="col-span-1" *ngIf="!data">
  <mat-form-field class="w-full" appearance="fill" floatLabel="always">
    <mat-label>Confirm Password</mat-label>
    <input
      matInput
      [type]="hideConfirmPassword ? 'password' : 'text'"
      id="confirmPassword"
      formControlName="confirmPassword"
      placeholder="Re-enter password"
      required
      autocomplete="new-password"
      form="dummy-form"
      name="confirm-new-password"
    />
    <button
      mat-icon-button
      matSuffix
      type="button"
      (click)="hideConfirmPassword = !hideConfirmPassword"
      [attr.aria-label]="'Toggle confirm password visibility'"
      [attr.aria-pressed]="hideConfirmPassword"
    >
      <mat-icon>
        {{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}
      </mat-icon>
    </button>

    <mat-error *ngIf="userForm.controls['confirmPassword'].hasError('required')">
      Confirm Password is required
    </mat-error>
    <mat-error *ngIf="userForm.hasError('passwordMismatch')">
      Passwords do not match
    </mat-error>
  </mat-form-field>
</div> -->




    <!-- Vendor Name (Only visible in Edit mode & if userType is 'vendor') -->
    <!-- Vendor Name (Shown Only for Vendors) -->
    <div *ngIf="isVendor && vendorName">
      <mat-form-field
        class="w-full"
        appearance="fill"
        floatLabel="always"
        disabled
      >
        <mat-label>Vendor Name</mat-label>
        <input matInput disabled [value]="vendorName" />
      </mat-form-field>
    </div>

    <div class="col-span-1 md:col-span-2">
      <fuse-alert
        *ngIf="showAlert"
        class="mt-8"
        [appearance]="'outline'"
        [showIcon]="false"
        [type]="alert.type"
        [@shake]="alert.type === 'error'"
      >
        {{ alert.message }}
      </fuse-alert>
    </div>

    <div class="col-span-1 md:col-span-2">
      <fuse-alert
        *ngIf="showAlert"
        class="mt-8"
        [appearance]="'outline'"
        [showIcon]="false"
        [type]="alert.type"
        [@shake]="alert.type === 'error'"
      >
        {{ alert.message }}
      </fuse-alert>
    </div>

    <!-- Submit Button -->
  </div>
  <div mat-dialog-actions class="flex justify-center align-center space-x-2">
    <button
      mat-button
      mat-dialog-close
      mat-raised-button
      class="bg-primary-200 bg-white text-black"
      (click)="closeDialog()"
    >
      Go back
    </button>

    <button mat-raised-button class="app-button" type="submit">
      {{ data ? "Update" : "Create" }}
    </button>
  </div>
</form>
